import { render, staticRenderFns } from "./prompt.vue?vue&type=template&id=2b63ac88&scoped=true"
import script from "./prompt.vue?vue&type=script&lang=js"
export * from "./prompt.vue?vue&type=script&lang=js"
import style0 from "./prompt.vue?vue&type=style&index=0&id=2b63ac88&prod&scoped=true&lang=less"
import style1 from "./prompt.vue?vue&type=style&index=1&id=2b63ac88&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63ac88",
  null
  
)

export default component.exports